/**
 * 用户信息
 *
 * VIP 信息项若是 undefined 则表示未知（部分接口不返回）
 */

/** 用户账号类型. */
export var UidSource = /*#__PURE__*/function (UidSource) {
  UidSource[UidSource["QQ"] = 1] = "QQ";
  UidSource[UidSource["QQUid"] = 2] = "QQUid";
  UidSource[UidSource["WeChat"] = 3] = "WeChat";
  UidSource[UidSource["WeWork"] = 4] = "WeWork";
  UidSource[UidSource["QFYF"] = 5] = "QFYF";
  UidSource[UidSource["QQGroup"] = 6] = "QQGroup";
  UidSource[UidSource["QQDiscGroup"] = 7] = "QQDiscGroup";
  UidSource[UidSource["TDocGroup"] = 8] = "TDocGroup";
  UidSource[UidSource["WeWorkDpt"] = 9] = "WeWorkDpt";
  UidSource[UidSource["QFYFDpt"] = 10] = "QFYFDpt";
  return UidSource;
}({});

/**
 * 表示存在但未知的用户 uid
 *
 * 如果需要判断是否是未知用户, 请直接判断对象引用是否等于 {@link UNKNOWN_USER}, 而不是判断 uid 或 nick.
 */
export var UNKNOWN_USER_ID = Symbol.for('__DRIVE_API_UNKNOWN_USER_ID__');

/**
 * 表示存在但未知的用户昵称
 *
 * 如果需要判断是否是未知用户, 请直接判断对象引用是否等于 {@link UNKNOWN_USER}, 而不是判断 uid 或 nick.
 */
export var UNKNOWN_USER_NICK = Symbol.for('__DRIVE_API_UNKNOWN_USER_NICK__');

/**
 * 表示存在但未知的用户的特殊对象常量
 *
 * 如果需要判断是否是未知用户, 请直接判断对象引用是否等于 {@link UNKNOWN_USER}, 而不是判断 uid 或 nick.
 */
export var UNKNOWN_USER = {
  uid: UNKNOWN_USER_ID,
  nick: UNKNOWN_USER_NICK
};
//# sourceMappingURL=user.js.map